import fetch from '@/fetch'
import { Debounce } from '@/utils'
import { i18n } from '@/i18n'
import Bus from '@/bus'

const check = Debounce((data, passes, msg, scope) => {
  fetch(`/api/${scope}/validate/${data}`)
    .then(res => {
      Bus.emit('validator:emailAvailable', { response: res, data, scope, msg, passes: true })
      passes()
    })
    .catch(res => {
      Bus.emit('validator:emailAvailable', { response: res, data, scope, msg, passes: false })
      passes(false, msg)
    })
}, 300)

export default Validator => {
  Validator.registerAsync('emailAvailable', function (data, attribute, req, passes) {
    let [type, email = data, organizationNumber] = attribute.split(':')
    if (!new Validator({ email }, { email: 'email' }).passes()) return passes()

    const i18nMap = {
      contact: 'contactHasAlreadyBeenAdded',
      user: 'emailHasAlreadyBeenAdded',
    }

    check([email, organizationNumber].filter(Boolean).join(':'), passes, i18n.t(i18nMap[type], { email }), type)
  })
}
